import React from 'react';

import {
  Select as SelectRoot,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@components/ui/select';

import { cn } from '@utils/index';
interface SelectProps {
  value?: string;
  onValueChange?: (value: string) => void;
  items?: { value: string; label: string }[];
  placeholder?: string;
  className?: string;
  error?: boolean;
  disabled?: boolean;
  contentClassName?: string;
}

export const Select = ({
  value,
  onValueChange,
  items = [],
  placeholder = 'Choose an option',
  className = '',
  error = false,
  disabled = false,
  contentClassName = '',
  ...props
}: SelectProps) => {
  return (
    <SelectRoot value={value} {...props} onValueChange={onValueChange}>
      <SelectTrigger
        aria-invalid={error}
        className={cn(
          '!border-select font-primary placeholder:text-neutral cursor-pointer rounded-[15px] border box-border h-auto bg-white text-[clamp(12px,1.5vw,16px)]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          className
        )}
        disabled={disabled}
      >
        <SelectValue placeholder={placeholder} className="text-text shrink-0" />
      </SelectTrigger>
      <SelectContent className={cn('font-primary bg-card', contentClassName)}>
        {items.map((item) => (
          <SelectItem
            key={item.value}
            value={item.value}
            className="hover:bg-card-foreground cursor-pointer"
          >
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </SelectRoot>
  );
};
